import {registerRoute as workbox_routing_registerRoute} from '/Users/joohyun/Documents/code/SciGrade/node_modules/workbox-routing/registerRoute.mjs';
import {ExpirationPlugin as workbox_expiration_ExpirationPlugin} from '/Users/joohyun/Documents/code/SciGrade/node_modules/workbox-expiration/ExpirationPlugin.mjs';
import {CacheFirst as workbox_strategies_CacheFirst} from '/Users/joohyun/Documents/code/SciGrade/node_modules/workbox-strategies/CacheFirst.mjs';
import {CacheableResponsePlugin as workbox_cacheable_response_CacheableResponsePlugin} from '/Users/joohyun/Documents/code/SciGrade/node_modules/workbox-cacheable-response/CacheableResponsePlugin.mjs';
import {NetworkFirst as workbox_strategies_NetworkFirst} from '/Users/joohyun/Documents/code/SciGrade/node_modules/workbox-strategies/NetworkFirst.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/Users/joohyun/Documents/code/SciGrade/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */




self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});

/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/core/systemrun.html",
    "revision": "23a01500420c5661682af5e6cc3502a5"
  },
  {
    "url": "/core/styling/style.min.css",
    "revision": "65a608b7d010ea2b87bb7ea7584ab875"
  },
  {
    "url": "/core/styling/style.css",
    "revision": "b67cbfd3995e07bba50358eaa64009fe"
  },
  {
    "url": "/core/scripts/runtime.min.js",
    "revision": "48689f86e688cea0cdcf0b7d760d4b76"
  },
  {
    "url": "/core/scripts/runtime.js",
    "revision": "d97dc692cac988c54247bee2fd50dbc4"
  },
  {
    "url": "/core/scripts/crispr_scripts.min.js",
    "revision": "3431813c793558235a346cc1de18dbde"
  },
  {
    "url": "/core/scripts/crispr_scripts.js",
    "revision": "4f4f531cc70bc17d90230a13bbe87a24"
  },
  {
    "url": "/core/scripts/APIandLibraries/tabletoCSV/package.json",
    "revision": "ef0258ebdf3f9d244d7d38c4c35ec723"
  },
  {
    "url": "/core/scripts/APIandLibraries/tabletoCSV/jquery.tabletoCSV.js",
    "revision": "1757e6cdbbbe5f5a1c330e2f182e24f2"
  },
  {
    "url": "/core/scripts/APIandLibraries/tabletoCSV/gulpfile.js",
    "revision": "c93880a7ac368dcd9b51d547948cbf8a"
  },
  {
    "url": "/core/scripts/APIandLibraries/tabletoCSV/example.html",
    "revision": "9b17ab0cdbf7acd33dfcfff87c410d2b"
  },
  {
    "url": "/core/scripts/APIandLibraries/tabletoCSV/bower.json",
    "revision": "79787e672bb7dc33e2a2e0bdc8467a38"
  },
  {
    "url": "/core/scripts/APIandLibraries/tabletoCSV/README.md",
    "revision": "d581efd7f3de48bdf77206307df41034"
  },
  {
    "url": "/core/scripts/APIandLibraries/tabletoCSV/dist/jquery.tabletoCSV.js",
    "revision": "38e3e2fcaff8b3a33f2e3bf01190e845"
  },
  {
    "url": "/core/scripts/APIandLibraries/jQuery/jquery.min.js",
    "revision": "a8e7cabd4d49dfaf0146678ee147dfc5"
  },
  {
    "url": "/core/scripts/APIandLibraries/Fonts/MaterialIcon.css",
    "revision": "c1cbea39f07b551807abd9967b809ffd"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/js/bootstrap.min.js",
    "revision": "a92b3364fb0a7349f2a1c31a7ad5ed5e"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/js/bootstrap.js",
    "revision": "52de67605c3d156f4958c83fa9cfc8d9"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/js/bootstrap.esm.min.js",
    "revision": "6ccf144f123da79e62d5e46a06f133b9"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/js/bootstrap.esm.js",
    "revision": "32e42b38a15f27b01f79bb13aad53714"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/js/bootstrap.bundle.min.js",
    "revision": "5cc1b73e70520fa84b1846afe0ec8fb6"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/js/bootstrap.bundle.js",
    "revision": "7d2c412531f05f39e97195f9b48a53dc"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/css/bootstrap.rtl.min.css",
    "revision": "53aa521e55523d4f35610e568c5991fd"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/css/bootstrap.rtl.css",
    "revision": "f50b588ab5764c08bb2e57da6bbe47c7"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/css/bootstrap.min.css",
    "revision": "1b1cb0e2be9a21f091a87691f20c6300"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/css/bootstrap.css",
    "revision": "32f9388da564ecf3f4f129021d3736a8"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/css/bootstrap-utilities.rtl.min.css",
    "revision": "1282e3b4ef0226816da34cd92a7ae69b"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/css/bootstrap-utilities.rtl.css",
    "revision": "95616dd04a2044a59dbefbc48c050891"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/css/bootstrap-utilities.min.css",
    "revision": "20d013574c70b2032e408e8f81a8fec9"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/css/bootstrap-utilities.css",
    "revision": "2609642eaa62f29a2275e0ced5a098fe"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/css/bootstrap-reboot.rtl.min.css",
    "revision": "c01f229a610e6f96bdb57fd287f48fc9"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/css/bootstrap-reboot.rtl.css",
    "revision": "0b4f19eb4846adc5a866b80c81bda434"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/css/bootstrap-reboot.min.css",
    "revision": "7c821536802bd2fa35701c22f2e96d36"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/css/bootstrap-reboot.css",
    "revision": "cb9d8d28a86d39db9b43030a8248b766"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/css/bootstrap-grid.rtl.min.css",
    "revision": "fc7e1eb57c409c379d21a8001a0f9b33"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/css/bootstrap-grid.rtl.css",
    "revision": "93f428651ed8b87b9986050f06e03cb2"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/css/bootstrap-grid.min.css",
    "revision": "895b9494c7178ac12ad9c56d81305665"
  },
  {
    "url": "/core/scripts/APIandLibraries/Bootstrap/css/bootstrap-grid.css",
    "revision": "4dd0ce2aa69225d64aacbded692fe756"
  },
  {
    "url": "/core/images/logo_transparent.svg",
    "revision": "d6abce258f77c56dfa6bb87765e3dfcf"
  },
  {
    "url": "/core/images/logo_transparent.png",
    "revision": "86746c9170e4cc9fccb363d0c54b3497"
  },
  {
    "url": "/core/images/logo_transparent-Dark.svg",
    "revision": "faef5b38e346a12888c11184c890292e"
  },
  {
    "url": "/core/images/logo_transparent-Dark.png",
    "revision": "cec8eede6a0b9a7e6da788d86edf6b37"
  },
  {
    "url": "/core/images/dna.svg",
    "revision": "7cf969d66011a6cddf39163fa202fa51"
  },
  {
    "url": "/core/images/dna.png",
    "revision": "d2778bf9fba581a4f4b8c2fca9abc9e8"
  },
  {
    "url": "/core/images/EDITmd/005_Algorithm.png",
    "revision": "934afcec1bad4f6cd1b39e799e6de5c2"
  },
  {
    "url": "/core/images/EDITmd/004_FeedbackPage.png",
    "revision": "e4ffddaa8a91c2c5547a89a4c6f47794"
  },
  {
    "url": "/core/images/EDITmd/002_SciGradePracticeGene.png",
    "revision": "a47cd17752a978f6e468985af11d5f3e"
  },
  {
    "url": "/core/images/BackgroundImage/homeBackground.webp",
    "revision": "fcb1240061569d6c355261f8d75a0f1b"
  },
  {
    "url": "/core/images/BackgroundImage/grey.webp",
    "revision": "44f3357b5a1f4d29ea3368de0f0f5279"
  },
  {
    "url": "/core/icon/screenshot3.webp",
    "revision": "19ef6219d8f3ba14ebf25b72e07240d8"
  },
  {
    "url": "/core/icon/screenshot2.webp",
    "revision": "87d56bb07395695fda9e04a30caf1672"
  },
  {
    "url": "/core/icon/screenshot1.webp",
    "revision": "426fd7165422ee95968d181411229d95"
  },
  {
    "url": "/core/icon/safari-pinned-tab.svg",
    "revision": "3a6f655958b21d384ae3dad886960d93"
  },
  {
    "url": "/core/icon/resoc.png",
    "revision": "4b94395e0972a350b0727a20e3d06baa"
  },
  {
    "url": "/core/icon/mstile-70x70.png",
    "revision": "b2902f78c5c0344f8a0558a8f36b97bf"
  },
  {
    "url": "/core/icon/mstile-310x310.png",
    "revision": "39af54c06ac44ebe9312f682ddd3602c"
  },
  {
    "url": "/core/icon/mstile-310x150.png",
    "revision": "7555e1760cd643b25105bfe4114eedfd"
  },
  {
    "url": "/core/icon/mstile-150x150.png",
    "revision": "4a6b569778e6b9d81aaee10df7c65284"
  },
  {
    "url": "/core/icon/mstile-144x144.png",
    "revision": "52d597709f2268268fd4063d34bd0ce7"
  },
  {
    "url": "/core/icon/maskable_icon_x96.png",
    "revision": "5269c50f0761a8aa50ae7201c28760c6"
  },
  {
    "url": "/core/icon/maskable_icon_x72.png",
    "revision": "0603508e30979836bd82b2d95dc0b1f4"
  },
  {
    "url": "/core/icon/maskable_icon_x512.png",
    "revision": "499293f67750aa3b60815cb50d8e3b72"
  },
  {
    "url": "/core/icon/maskable_icon_x48.png",
    "revision": "c521515543d0ccc88a843690484dfefe"
  },
  {
    "url": "/core/icon/maskable_icon_x384.png",
    "revision": "83527cdabf00617fb5b56df08a08b2a3"
  },
  {
    "url": "/core/icon/maskable_icon_x192.png",
    "revision": "bd977cf9153d6ebb3e8d8f79b4f100b6"
  },
  {
    "url": "/core/icon/maskable_icon_x128.png",
    "revision": "cf5ea1b4cd68730505d36d59d3c8b04d"
  },
  {
    "url": "/core/icon/maskable_icon.png",
    "revision": "94a300afab67912c4aa267989a725155"
  },
  {
    "url": "/core/icon/manifest.json",
    "revision": "ec78f1b4aaf3e8be6d7db11ef45fbf72"
  },
  {
    "url": "/core/icon/favicon.ico",
    "revision": "ea57adfd4a62355e9f4c2b46ef21600f"
  },
  {
    "url": "/core/icon/favicon-32x32.png",
    "revision": "a6296dcec5e5a6449807f753d885507d"
  },
  {
    "url": "/core/icon/favicon-16x16.png",
    "revision": "f9e844d671e8e4b80174f643fe4dcf56"
  },
  {
    "url": "/core/icon/apple-touch-icon.png",
    "revision": "ced32ca13a0c404c96fc081dca7473eb"
  },
  {
    "url": "/core/icon/apple-touch-icon-precomposed.png",
    "revision": "ced32ca13a0c404c96fc081dca7473eb"
  },
  {
    "url": "/core/icon/apple-touch-icon-76x76.png",
    "revision": "448377ba1760c41142b83ffd0fa47163"
  },
  {
    "url": "/core/icon/apple-touch-icon-76x76-precomposed.png",
    "revision": "448377ba1760c41142b83ffd0fa47163"
  },
  {
    "url": "/core/icon/apple-touch-icon-72x72.png",
    "revision": "819a43b6e5dc4991e399ff9b5d9b34b3"
  },
  {
    "url": "/core/icon/apple-touch-icon-72x72-precomposed.png",
    "revision": "819a43b6e5dc4991e399ff9b5d9b34b3"
  },
  {
    "url": "/core/icon/apple-touch-icon-60x60.png",
    "revision": "37be5e105d7a21fc8f3c437508dca233"
  },
  {
    "url": "/core/icon/apple-touch-icon-60x60-precomposed.png",
    "revision": "37be5e105d7a21fc8f3c437508dca233"
  },
  {
    "url": "/core/icon/apple-touch-icon-57x57.png",
    "revision": "b3e1d7fc553b33f086791c138d69bba1"
  },
  {
    "url": "/core/icon/apple-touch-icon-57x57-precomposed.png",
    "revision": "b3e1d7fc553b33f086791c138d69bba1"
  },
  {
    "url": "/core/icon/apple-touch-icon-180x180.png",
    "revision": "ced32ca13a0c404c96fc081dca7473eb"
  },
  {
    "url": "/core/icon/apple-touch-icon-180x180-precomposed.png",
    "revision": "ced32ca13a0c404c96fc081dca7473eb"
  },
  {
    "url": "/core/icon/apple-touch-icon-152x152.png",
    "revision": "8d46a8911ef72a562c97570d452f83ac"
  },
  {
    "url": "/core/icon/apple-touch-icon-152x152-precomposed.png",
    "revision": "8d46a8911ef72a562c97570d452f83ac"
  },
  {
    "url": "/core/icon/apple-touch-icon-144x144.png",
    "revision": "52d597709f2268268fd4063d34bd0ce7"
  },
  {
    "url": "/core/icon/apple-touch-icon-144x144-precomposed.png",
    "revision": "52d597709f2268268fd4063d34bd0ce7"
  },
  {
    "url": "/core/icon/apple-touch-icon-120x120.png",
    "revision": "c61a5acca54b104d7fe15fbc473796b5"
  },
  {
    "url": "/core/icon/apple-touch-icon-120x120-precomposed.png",
    "revision": "c61a5acca54b104d7fe15fbc473796b5"
  },
  {
    "url": "/core/icon/apple-touch-icon-114x114.png",
    "revision": "7b0f0af98c190974af01f605b117fc18"
  },
  {
    "url": "/core/icon/apple-touch-icon-114x114-precomposed.png",
    "revision": "7b0f0af98c190974af01f605b117fc18"
  },
  {
    "url": "/core/icon/android-chrome-96x96.png",
    "revision": "497e53074c189be631a8368192870f02"
  },
  {
    "url": "/core/icon/android-chrome-72x72.png",
    "revision": "a2b1197f79059981d8a19ba65ce73e6d"
  },
  {
    "url": "/core/icon/android-chrome-512x512.png",
    "revision": "d5a6869fb6a0d95e1c1398de5aac2278"
  },
  {
    "url": "/core/icon/android-chrome-48x48.png",
    "revision": "7ac44965ab502f17205e2d048d3e1580"
  },
  {
    "url": "/core/icon/android-chrome-384x384.png",
    "revision": "45ea1a83b4d26a9224844344602ad69e"
  },
  {
    "url": "/core/icon/android-chrome-36x36.png",
    "revision": "c3603b9735bb8397b0ac5351da9e94ed"
  },
  {
    "url": "/core/icon/android-chrome-256x256.png",
    "revision": "d80b94ad67334b9560e3cefaf8b04677"
  },
  {
    "url": "/core/icon/android-chrome-192x192.png",
    "revision": "f94fc51b10052dcc8f91e04945a618b8"
  },
  {
    "url": "/core/icon/android-chrome-144x144.png",
    "revision": "859cb36c4d6354a1d76e8d9692fdd88d"
  },
  {
    "url": "/core/data/Benchling_gRNA_Outputs.json",
    "revision": "515b0830b197e126a294fb15cd6d8e89"
  },
  {
    "url": "/core/data/eBFP/eBFP.fasta",
    "revision": "a30dc131549dc5fbbaa59128830ca49c"
  },
  {
    "url": "/core/data/eBFP/Benchling_gRNA_outputs.xlsx",
    "revision": "cb29f7f64c8c0f44cfe58c3504af0d2b"
  },
  {
    "url": "/core/data/HBB/HBB.fasta",
    "revision": "0314a959f59b730536fddec088d4a6c5"
  },
  {
    "url": "/core/data/HBB/Benchling_gRNA_Outputs.xlsx",
    "revision": "571ef05c0a5fc985423f08ab13e3fc71"
  },
  {
    "url": "/core/data/CCR5/CCR5.fasta",
    "revision": "60232b31119c5c0dfd9c59216f46928a"
  },
  {
    "url": "/core/data/CCR5/Benchling_gRNA_Outputs.xlsx",
    "revision": "d204b7de85c0def6a40789a3104dd975"
  },
  {
    "url": "/core/data/Background_info/gene_background_info.json",
    "revision": "ebeaca222ceb2e2354f6b2bacb6d0b26"
  },
  {
    "url": "/core/data/APOE/Benchling_gRNA_Outputs.xlsx",
    "revision": "d728b00ab3559732abc114c43893ba7e"
  },
  {
    "url": "/core/data/APOE/APOE.fasta",
    "revision": "9955beb43e9fd5a6e506cb9853ef13f2"
  },
  {
    "url": "/core/data/ACTN3/Benchling_gRNA_Outputs.xlsx",
    "revision": "9d9a05ae5858671f89b87ae185b4917b"
  },
  {
    "url": "/core/data/ACTN3/ACTN3.fasta",
    "revision": "a5ad42f7acbecbc28bed864b8377c5d4"
  }
], {});

workbox_routing_registerRoute(/\.(?:png|jpg|jpeg|webp|ico|svg)$/, new workbox_strategies_CacheFirst({ "cacheName":"images", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 10 })] }), 'GET');
workbox_routing_registerRoute(/\.html$/, new workbox_strategies_NetworkFirst({ "cacheName":"html","networkTimeoutSeconds":10, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 50 }), new workbox_cacheable_response_CacheableResponsePlugin({ statuses: [ 0, 200 ] })] }), 'GET');
workbox_routing_registerRoute(/\.(?:css|js)$/, new workbox_strategies_NetworkFirst({ "cacheName":"assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 50 }), new workbox_cacheable_response_CacheableResponsePlugin({ statuses: [ 0, 200 ] })] }), 'GET');


